import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { LoadingSkeleton } from 'components';

import DetailItem from './DetailItem';

const LinkedMembersManagement = ({ member, status, memberType, stats, loading }) => {
	return (
		<Box>
			<Typography variant="h5" fontWeight="600" mb={3}>
				Linked Members Management:
			</Typography>
			<Stack spacing={1}>
				<LoadingSkeleton isLoading={loading}>
					<DetailItem label="Member" value={member} />
				</LoadingSkeleton>
				<LoadingSkeleton isLoading={loading}>
					<DetailItem label="Member Status" value={status} />
				</LoadingSkeleton>
				<LoadingSkeleton isLoading={loading}>
					<DetailItem label="Member Type" value={memberType} />
				</LoadingSkeleton>
				<LoadingSkeleton isLoading={loading}>
					<DetailItem label="Linked Members" value={stats} />
				</LoadingSkeleton>
			</Stack>
		</Box>
	);
};

export default LinkedMembersManagement;
